const baseURL = process.env.REACT_APP_GWAPI ?? ''

type HttpResponse<T = unknown> = {
  data: T
}

type HttpError = Error & {
  response?: {
    data: unknown
  }
}

const combineURLs = (base: string, path: string) => {
  if (!path) return base
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
}

const buildUrl = (path: string) => {
  if (path.startsWith('http')) return path
  return combineURLs(baseURL, path)
}

const parseResponse = async <T>(response: Response): Promise<HttpResponse<T>> => {
  let data: unknown = null
  const text = await response.text()

  if (text) {
    const contentType = response.headers.get('content-type')
    data = contentType?.includes('application/json') ? JSON.parse(text) : text
  }

  if (!response.ok) {
    const error = new Error('Request failed') as HttpError
    error.response = { data }
    throw error
  }

  return { data: data as T }
}

const request = <T>(method: string, path: string, body?: unknown): Promise<HttpResponse<T>> => {
  const options: RequestInit = { method }

  if (body !== undefined) {
    options.headers = { 'Content-Type': 'application/json' }
    options.body = JSON.stringify(body)
  }

  return fetch(buildUrl(path), options).then((response) => parseResponse<T>(response))
}

const http = {
  get: <T = unknown>(path: string) => request<T>('GET', path),
  patch: <T = unknown>(path: string, body?: unknown) => request<T>('PATCH', path, body)
}

export default http
